import _ from 'lodash'

export const getColumnPath = (cols, id) => {
  const findCol = (path) => (col, index) => {
    if (col.id === id) {
      return [...path, index]
    } else {
      return _.flatMap(_.get(col, 'columns', []), findCol([...path, index, 'columns']))
    }
  }
  return _.flatMap(cols, findCol([]))
}

export const getColumnSubPath = (cols, id) => {
  const findCol = (path) => (col, index) => {
    if (col.id === id) {
      return [...path, index]
    } else if (_.size(col.columns) === 0) {
      if (col?.meta?.subCtrl?.Type === 'PowerTable') {
        return _.flatMap(
          _.get(col, 'meta.subCtrl.Props.columns', []),
          findCol([...path, index, 'meta', 'subCtrl', 'Props', 'columns'])
        )
      } else {
        return []
      }
    } else {
      return _.flatMap(_.get(col, 'columns', []), findCol([...path, index, 'columns']))
    }
  }
  return _.flatMap(cols, findCol([]))
}
